import { gql } from '@apollo/client';

export const LOGIN = gql`
    mutation login($email: String!, $password: String!, $otp: String!) {
        tokenAuth(email: $email, password: $password, otp: $otp) {
            refreshExpiresIn
            token
            refreshToken
            user {
                id
                email
                firstName
                lastName
                username
            }
        }
    }
`;

export const REFRESH_TOKEN = gql`
    mutation refreshToken($token: String) {
        refreshToken(refreshToken: $token) {
            refreshExpiresIn
            token
            refreshToken
        }
    }
`;

export const SEND_OTP = gql`
    mutation sentOtp($email: String!, $password: String!) {
        sendOtpCode(email: $email, password: $password) {
            success
            message
            phoneNumber
            otpMethod
        }
    }
`;

// TOTP 2FA Mutations
export const CHECK_2FA_METHOD = gql`
    mutation check2faMethod($email: String!, $password: String!) {
        check2faMethod(email: $email, password: $password) {
            method
            requiresSmsSend
        }
    }
`;

export const VERIFY_TOTP_LOGIN = gql`
    mutation verifyTotpLogin($email: String!, $password: String!, $totpCode: String!) {
        verifyTotpLogin(email: $email, password: $password, totpCode: $totpCode) {
            token
            refreshToken
            user {
                id
                email
                firstName
                lastName
                username
            }
        }
    }
`;

export const SETUP_TOTP = gql`
    mutation setupTotp {
        setupTotp {
            secret
            provisioningUri
        }
    }
`;

export const VERIFY_TOTP_SETUP = gql`
    mutation verifyTotpSetup($code: String!) {
        verifyTotpSetup(code: $code) {
            success
            backupCodes
        }
    }
`;

export const SET_PREFERRED_2FA_METHOD = gql`
    mutation setPreferred2faMethod($method: String!) {
        setPreferred2FaMethod(method: $method) {
            success
            preferredMethod
        }
    }
`;

export const REGENERATE_BACKUP_CODES = gql`
    mutation regenerateBackupCodes {
        regenerateBackupCodes {
            success
            backupCodes
        }
    }
`;

export const DISABLE_TOTP = gql`
    mutation disableTotp($code: String!) {
        disableTotp(code: $code) {
            success
        }
    }
`;

export const GET_2FA_SETTINGS = gql`
    mutation get2faSettings {
        get2FaSettings {
            settings {
                preferredMethod
                totpEnabled
                backupCodesRemaining
                lastUsedAt
            }
        }
    }
`;
